import React, { useEffect, useState, useRef, useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
import Swal from "sweetalert2";
import config from "../../config";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";

function DataNotFound10() {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [showSubmit, setShowSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);

  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [sessionList, setSessionList] = useState([]);

  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };

  const session1Ref = useRef(null);
  const session2Ref = useRef(null);

  const [isPreviewed, setIsPreviewed] = useState(false);

  // const [selectedImage, setSelectedImage] = useState(null);
  // const [pendingFileName, setPendingFileName] = useState("");
  // const [pendingFileKey, setPendingFileKey] = useState("");
  // const [cropModalOpen, setCropModalOpen] = useState(false);
  // const [startDate, setStartDate] = useState(new Date());

  const [language1_2, setLanguage1_2] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([{}, {}, {}]);

  const [lang1, setLang1] = useState("");
  const [lang2, setLang2] = useState("");
  const [addisubj, setAddisubj] = useState("");

  const [formData, setFormData] = useState({
    /* academiC_SESSION1: "",
    academiC_SESSION2: "", */
    academiC_SESSION: "",
    registratioN_NO: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    /* category_choice: "", */
    board_name: "JAC",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    apaar_id: "",
    roll_no: "",
    /* section_val: "", */
    /* roll_no: "", */
    /* pen_no: "", */
  });

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassx");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const subjects = [
      formData.language_one,
      formData.language_two,
      formData.compulsory_one,
      formData.compulsory_two,
      formData.compulsory_three,
      formData.additional_subject,
    ];
    const uniqueSubjects = new Set(subjects.filter(Boolean)); // Remove empty/null/undefined
    if (uniqueSubjects.size !== subjects.length) {
      await Swal.fire({
        icon: "warning",
        title: "Duplicate Subjects",
        text: "Each subject must be unique. Please check your subject selections.",
      });
      return;
    }
    const payload = {
      /* academiC_SESSION:
        formData.academiC_SESSION1 && formData.academiC_SESSION2
          ? `${formData.academiC_SESSION1}-${formData.academiC_SESSION2}`
          : "", */
      ROLL_NO: formData.roll_no || "",
      academiC_SESSION: formData.academiC_SESSION || "",
      registratioN_NO: formData.registratioN_NO || "",
      /* studenT_EXAM_SUB_CATEGORY: formData.category_choice, */
      candidatE_NAME: formData.candidate_name,
      gender: formData.gender,
      dob: formData.date_of_birth,
      fatheR_NAME: formData.fathers_name,
      motheR_NAME: formData.mothers_name,
      religion: formData.religion,
      aadhaR_CARD: formData.aadhaar_no.replace(/\s/g, ""),
      divyang: formData.divyang_val,
      caste: formData.caste_val,
      contacT_NO: formData.contact_no || "",
      emaiL_ID: formData.email_id || "",
      area: formData.area || "",
      state: formData.state_val || "",
      districT_ID: formData.district_val || "",
      block: formData.block_val,
      address: formData.address_val.toUpperCase(),
      pincode: formData.pin_no,
      /* clasS_ROLL_NO: formData.roll_no, */
      /* section: formData.section_val, */
      mediuM_OF_EXAM: formData.examination_medium,
      apaaR_ID: formData.apaar_id || "",
      SUBJECT_1_CODE: formData.language_one,
      SUBJECT_2_CODE: formData.language_two,
      SUBJECT_3_CODE: formData.compulsory_one,
      SUBJECT_4_CODE: formData.compulsory_two,
      SUBJECT_5_CODE: formData.compulsory_three,
      SUBJECT_6_CODE: formData.additional_subject,
      schooL_DIST_CODE: sessionStorage.getItem("district"),
      /* peN_NO: formData.pen_no || "", */
    };
    // console.log(payload);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/InsertDataNotFound_CL10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      // console.log(data);
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
          confirmButtonText: "OK",
        });
        navigate("/class-x-data-not-found-list");

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection and try again.",
      });
    }
  };
  const getFilteredSubjects = (excludeCodes = [], mode = "main") => {
    const hasHN = excludeCodes.includes("HNA") || excludeCodes.includes("HNB");

    const source = mode === "additional" ? additional : language1_2;

    return source.filter((subj) => {
      const subjId = subj.subjecT_ID;

      // Common logic
      if (hasHN && (subjId === "HNA" || subjId === "HNB")) return false;
      if (excludeCodes.includes(subjId)) return false;

      return true;
    });
  };

  const getFilteredSubjectOptions = (excludeCodes = [], mode = "main") =>
    getFilteredSubjects(excludeCodes, mode).map((subj) => ({
      value: subj.subjecT_ID,
      label: subj.subjecT_NAME || "",
    }));

  const additionalOptions = additional.map((subj) => ({
    value: subj.subjecT_ID,
    label: subj.subjecT_NAME || "",
  }));
  useEffect(() => {
    // console.log(mode, candidateid);
    const token = sessionStorage.getItem("tokenclassx");
    const fetchPageLoadData10 = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PageLoadRegistrationData_CL9`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          setLoading(false);
          // console.log("response data:", data);
          setBlockList(data.data.blockList);
          setCasteList(data.data.casteList);
          setDistrictList(data.data.districtList);
          setDivyangList(data.data.divyangList);
          setMediumList(data.data.mediumList);
          setReligionList(data.data.religionList);
          setStateList(data.data.stateList);
          setSessionList(data.data.noDataFoundSessionList);
          setLanguage1_2(data.data.languageSubjects || "");
          setAdditional(data.data.additionalSubjects || "");
          setCompulsary(data.data.compulsorySubjects || "");

          setEndDate(data.data.cL10EndDate.cL_10_REGISTRATION_END_DATE);

          // alert(`Registration End Date: ${data.data.cL9EndDate.cL_9_REGISTRATION_END_DATE}`);
          // alert(`Current Date: ${currentDate}`);
          // console.log(data .data.compulsorySubjects[0].subjecT_NAME);
          setFormData({
            compulsory_one: data.data?.compulsorySubjects[0]?.subjecT_ID,
            compulsory_two: data.data?.compulsorySubjects[1]?.subjecT_ID,
            compulsory_three: data.data?.compulsorySubjects[2]?.subjecT_ID,
          });
          // console.log(data.data?.COMPULSARY_SUB[0]?.SUBJECT_ID);
        } else {
          setLoading(false);
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        setLoading(false);
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }
    };
    fetchPageLoadData10();
  }, []);
  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Formatting logic
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }
    /* if (name === "academiC_SESSION1" && formattedValue.length === 4) {
      session2Ref.current.focus();
    } */
    if (name === "aadhaar_no") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      formattedValue = digitsOnly.replace(
        /(\d{4})(\d{4})(\d{1,4})?/,
        (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" ")
      );
    }
    /* if (name === "section_val") {
      setFormData((prev) => ({
        ...prev,
        section_val: value,
        roll_no: "", // reset class roll no
      }));
    } */
    // if (name === "apaar_id") {
    //   formattedValue = value
    //     .replace(/\D/g, "")
    //     .slice(0, 12)
    //     .replace(/(\d{4})(?=\d)/g, "$1  ")
    //     .trim();
    // }

    if (name === "contact_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }
    if (name === "roll_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }
    if (name === "pin_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 6);
    }

    /* if (name === "roll_no") {
      formattedValue = value.replace(/\D/g, "");
    } */

    if (name === "address_val") {
      formattedValue = value.replace(/[^a-zA-Z0-9 ,]/g, "");
    }

    if (name === "email_id") {
      formattedValue = value.toLowerCase().replace(/[^a-z0-9@._]/g, "");
    }

    // Dependent dropdown handling
    if (name === "state_val") {
      setFormData((prev) => ({
        ...prev,
        state_val: formattedValue,
        district_val: "", // reset district
        block_val: "", // reset block
      }));
    } else if (name === "district_val") {
      setFormData((prev) => ({
        ...prev,
        district_val: formattedValue,
        block_val: "", // reset block
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
    /* if (name === "academiC_SESSION1" || name === "academiC_SESSION2") {
      formattedValue = value.replace(/[^0-9/-]/g, "");
    } */

    // Restrict Registration Number: only numbers and special characters (_-)
    if (name === "registratioN_NO") {
      formattedValue = value.replace(/[^0-9_-]/g, "");
    }
    // Clear validation errors on input change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  /* const handleKeyDown = (e) => {
    if (
      e.key === "Backspace" &&
      e.target.name === "academiC_SESSION2" &&
      e.target.value.length === 0
    ) {
      session1Ref.current.focus();
    }
  }; */
  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData({
        ...formData,
        date_of_birth: `${dd}-${mm}-${yyyy}`, // store dd-mm-yyyy
      });
    } else {
      setFormData({
        ...formData,
        date_of_birth: "",
      });
    }
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();
    const newErrors = {};
    // const trimmed = (val) => (val || "").trim();
    setTimeout(() => {
      if (!trimmed(formData.candidate_name)) {
        newErrors.candidate_name = "Candidate name is required.";
      } else if (/\d/.test(formData.candidate_name)) {
        newErrors.candidate_name = "Candidate name cannot contain numbers.";
      }

      if (!trimmed(formData.fathers_name)) {
        newErrors.fathers_name = "Father's name is required.";
      } else if (/\d/.test(formData.fathers_name)) {
        newErrors.fathers_name = "Father's name cannot contain numbers.";
      }

      if (!trimmed(formData.mothers_name)) {
        newErrors.mothers_name = "Mother's name is required.";
      } else if (/\d/.test(formData.mothers_name)) {
        newErrors.mothers_name = "Mother's name cannot contain numbers.";
      }
      if (!trimmed(formData.registratioN_NO)) {
        newErrors.registratioN_NO = "Registration No. is required.";
      } else if (!/^\d{12,14}$/.test(formData.registratioN_NO)) {
        newErrors.registratioN_NO =
          "Registration number must be between 12 and 14 digits.";
      }
      const roll_no = (formData.roll_no || "").replace(/\D/g, "");
      if (!roll_no) {
        newErrors.roll_no = "Roll No. is required.";
      }
      if (!formData.gender) {
        newErrors.gender = "Gender is required.";
      }

      if (!formData.date_of_birth) {
        newErrors.date_of_birth = "Date of birth is required.";
      }

      if (!formData.religion) {
        newErrors.religion = "Religion is required.";
      }

      if (formData.nationality === "") {
        newErrors.nationality = "Nationality is required.";
      }

      const aadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
      if (!aadhaar) {
        newErrors.aadhaar_no = "Aadhaar number is required.";
      } else if (!/^\d{12}$/.test(aadhaar)) {
        newErrors.aadhaar_no = "Aadhaar number must be 12 digits.";
      }

      if (!formData.divyang_val) {
        newErrors.divyang_val = "Divyang selection is required.";
      }

      if (!formData.caste_val) {
        newErrors.caste_val = "Caste is required.";
      }

      if (!formData.area) {
        newErrors.area = "Area is required.";
      }

      if (!formData.state_val) {
        newErrors.state_val = "State is required.";
      }

      if (!formData.district_val) {
        newErrors.district_val = "District is required.";
      }

      if (!formData.block_val) {
        newErrors.block_val = "Block is required.";
      }

      if (!trimmed(formData.address_val)) {
        newErrors.address_val = "Address is required.";
      }

      if (!trimmed(formData.pin_no)) {
        newErrors.pin_no = "Pin code is required.";
      } else if (!/^\d{6}$/.test(formData.pin_no)) {
        newErrors.pin_no = "Pin code must be 6 digits.";
      }
      /* if (formData.pen_no && !/^\d{12}$/.test(formData.pen_no)) {
        newErrors.pen_no = "PEN No. must be exactly 12 digits.";
      } */
      if (!trimmed(formData.contact_no)) {
        newErrors.contact_no = "Contact number is required.";
      } else if (!/^\d{10}$/.test(formData.contact_no)) {
        newErrors.contact_no = "Contact number must be 10 digits.";
      }

      if (!trimmed(formData.email_id)) {
      } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email_id)) {
        newErrors.email_id = "Invalid email format.";
      }

      /* if (!formData.category_choice) {
        newErrors.category_choice = "Category choice is required.";
      } */

      if (formData.board_name === "") {
        newErrors.board_name = "Board name is required.";
      }

      if (!formData.examination_medium) {
        newErrors.examination_medium = "Medium of examination is required.";
      }

      if (!formData.language_one) {
        newErrors.language_one = "Language I subject is required.";
      }

      if (!formData.language_two) {
        newErrors.language_two = "Language II subject is required.";
      }
      if (!formData.academiC_SESSION) {
        newErrors.academiC_SESSION = "Academic Session is required.";
      }
      /* if (!trimmed(formData.academiC_SESSION1)) {
        newErrors.academiC_SESSION1 = "Academic Session is required.";
      } else if (!/^\d{4}$/.test(formData.academiC_SESSION1)) {
        newErrors.academiC_SESSION1 = "Academic Session must be 4 digits.";
      }
      if (!trimmed(formData.academiC_SESSION2)) {
        newErrors.academiC_SESSION2 = "Academic Session is required.";
      } else if (!/^\d{4}$/.test(formData.academiC_SESSION2)) {
        newErrors.academiC_SESSION2 = "Academic Session must be 4 digits.";
      } */

      if (formData.language_one && formData.language_two) {
        const validLangs = ["HNA", "HNB", "ENG"];
        const lang1Valid = validLangs.includes(formData.language_one);
        const lang2Valid = validLangs.includes(formData.language_two);

        if (!lang1Valid && !lang2Valid) {
          Swal.fire(
            "Error",
            "Amongst Hindi - A, Hindi - B & English one subject has to be taken as Language I or Language II.",
            "error"
          );
          setLang1("");
          setLang2("");
          setFormData((prev) => ({
            ...prev,
            language_one: "",
            language_two: "",
          }));
          newErrors.language_one = "Language I subject is required.";
          newErrors.language_two = "Language II subject is required.";
        }
      }

      if (!trimmed(formData.compulsory_one)) {
        newErrors.compulsory_one = "Compulsory I subject is required.";
      }

      if (!trimmed(formData.compulsory_two)) {
        newErrors.compulsory_two = "Compulsory II subject is required.";
      }

      if (!trimmed(formData.compulsory_three)) {
        newErrors.compulsory_three = "Compulsory III subject is required.";
      }

      if (!formData.additional_subject) {
        newErrors.additional_subject = "Additional subject is required.";
      }

      /* if (!formData.section_val) {
        newErrors.section_val = "Section is required.";
      } */

      /* if (!trimmed(formData.roll_no)) {
        newErrors.roll_no = "Class roll number is required.";
      } */

      const subjectFields = [
        formData.language_one,
        formData.language_two,
        formData.compulsory_one,
        formData.compulsory_two,
        formData.compulsory_three,
        formData.additional_subject,
      ];

      const subjectCounts = subjectFields.reduce((acc, subj) => {
        if (subj) {
          acc[subj] = (acc[subj] || 0) + 1;
        }
        return acc;
      }, {});

      const duplicateSubjects = Object.keys(subjectCounts).filter(
        (subj) => subjectCounts[subj] > 1
      );

      if (duplicateSubjects.length > 0) {
        Swal.fire(
          "Duplicate Subject Detected",
          `The subject "${duplicateSubjects[0]}" is selected multiple times. Each subject must be unique.`,
          "error"
        );
        return;
      }

      setErrors(newErrors);
      const noErrors = Object.keys(newErrors).length === 0;
      setShowSubmit(noErrors);
      if (!noErrors) {
        const firstErrorKey = Object.keys(newErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorKey}"]`
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsPreviewed(true);
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div class="container-scroller">
      <Navbar10 />
      <div class="container-fluid page-body-wrapper">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Sidebar10 />
        <div class="main-panel">
          {/* {parseDate(currentDate) >= parseDate(EndDate) ? (
            <div
              class="content-wrapper"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h1 className="text-danger">
                <strong>Registration is closed.</strong>
              </h1>
            </div>
          ) : ("")} */}

          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1 className="text-danger">
                    <i class="fa fa-user-plus"></i>&nbsp; Add Data Not Found
                    Student
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          navigate("/class-x-dashboard");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active"> Add Student</li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 mb-4">
                <div class="card">
                  <div class="card-header">
                    <h4 class="mb-0 p-2">Student Details</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div
                        class="col-lg-9"
                        style={{ borderRight: "1px solid #CED4DA" }}
                      >
                        <div class="row">
                          <div className="col-lg-6 col-m-6">
                            <div className="form-group mb-3">
                              <label>
                                Registration Number
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm  ${
                                  errors.registratioN_NO ? "is-invalid" : ""
                                }`}
                                maxlength="14"
                                name="registratioN_NO"
                                id="registratioN_NO"
                                value={formData.registratioN_NO}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.registratioN_NO && (
                                <div className="text-danger mt-1 small">
                                  {errors.registratioN_NO}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-3 col-m-3">
                            <div className="form-group mb-3">
                              <label>
                                Roll Code
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={sessionStorage.getItem("schoolCode")}
                                onChange={handleChange}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-m-3">
                            <div className="form-group mb-3">
                              <label>
                                Roll No.
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                name="roll_no"
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.roll_no ? "is-invalid" : ""
                                }`}
                                value={formData.roll_no}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.roll_no && (
                                <div className="text-danger mt-1 small">
                                  {errors.roll_no}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-6 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Name of Student{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  autoComplete="off"
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.candidate_name ? "is-invalid" : ""
                                  }`}
                                  name="candidate_name"
                                  maxLength="35"
                                  placeholder="Candidate Name"
                                  value={formData.candidate_name}
                                  onChange={handleChange}
                                  onBlur={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      candidate_name: e.target.value
                                        .trim()
                                        .replace(/\s+/g, " "),
                                    }))
                                  }
                                  disabled={isPreviewed}
                                />

                                <span
                                  class="input-group-text padding-13"
                                  id="chars"
                                >
                                  {35 - (formData.candidate_name?.length || 0)}
                                </span>
                              </div>
                              {errors.candidate_name && (
                                <div className="text-danger mt-1 small">
                                  {errors.candidate_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div className="form-group mb-3">
                              <label>
                                Gender <span className="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-select-sm ${
                                  errors.gender ? "is-invalid" : ""
                                }`}
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Select</option>
                                <option value="MALE">MALE</option>
                                <option value="FEMALE">FEMALE</option>
                                <option value="TRANSGENDER">TRANSGENDER</option>
                              </select>
                              {errors.gender && (
                                <div className="text-danger mt-1 small">
                                  {errors.gender}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Date of Birth <span class="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={
                                  formData.date_of_birth
                                    ? (() => {
                                        const [dd, mm, yyyy] =
                                          formData.date_of_birth.split("-");
                                        return new Date(
                                          Number(yyyy),
                                          Number(mm) - 1,
                                          Number(dd)
                                        );
                                      })()
                                    : null
                                }
                                onChange={(date) => handleChangeDate(date)}
                                dateFormat="dd-MM-yyyy"
                                className={`form-control form-control-sm ${
                                  errors.date_of_birth ? "is-invalid" : ""
                                }`}
                                placeholderText="dd-mm-yyyy"
                                disabled={isPreviewed}
                                onKeyDown={(e) => e.preventDefault()}
                                maxDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={60}
                              />

                              {errors.date_of_birth && (
                                <div className="text-danger mt-1 small">
                                  {errors.date_of_birth}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <div class="form-group  mb-3">
                              <label>
                                Father’s Name
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  autoComplete="off"
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.fathers_name ? "is-invalid" : ""
                                  }`}
                                  name="fathers_name"
                                  maxLength="35"
                                  placeholder="Father’s Name"
                                  value={formData.fathers_name}
                                  onChange={handleChange}
                                  onBlur={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      fathers_name: e.target.value
                                        .trim()
                                        .replace(/\s+/g, " "),
                                    }))
                                  }
                                  disabled={isPreviewed}
                                />
                                <span
                                  class="input-group-text padding-13"
                                  id="chars1"
                                >
                                  {35 - (formData.fathers_name?.length || 0)}
                                </span>
                              </div>
                              {errors.fathers_name && (
                                <div className="text-danger mt-1 small">
                                  {errors.fathers_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <div class="form-group  mb-3">
                              <label>
                                Mother’s Name <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  autoComplete="off"
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.mothers_name ? "is-invalid" : ""
                                  }`}
                                  name="mothers_name"
                                  maxLength="35"
                                  placeholder="Mother’s Name"
                                  value={formData.mothers_name}
                                  onChange={handleChange}
                                  onBlur={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      mothers_name: e.target.value
                                        .trim()
                                        .replace(/\s+/g, " "),
                                    }))
                                  }
                                  disabled={isPreviewed}
                                />
                                <span
                                  class="input-group-text padding-13"
                                  id="chars2"
                                >
                                  {35 - (formData.mothers_name?.length || 0)}
                                </span>
                              </div>
                              {errors.mothers_name && (
                                <div className="text-danger mt-1 small">
                                  {errors.mothers_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Religion <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control disable ${
                                  errors.religion ? "is-invalid" : ""
                                }`}
                                name="religion"
                                id="religion"
                                value={formData.religion}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Choose Religion</option>
                                {religionList.map((religion) => (
                                  <option
                                    key={religion.religioN_ID}
                                    value={religion.religioN_ID}
                                  >
                                    {religion.religioN_NAME}
                                  </option>
                                ))}
                              </select>
                              {errors.religion && (
                                <div className="text-danger mt-1 small">
                                  {errors.religion}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Nationality <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={formData.nationality}
                                disabled
                              />
                              {errors.nationality && (
                                <div className="text-danger mt-1 small">
                                  {errors.nationality}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <div class="form-group  mb-3">
                              <label>
                                Student Aadhaar Number{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.aadhaar_no ? "is-invalid" : ""
                                }`}
                                name="aadhaar_no"
                                maxLength="14"
                                placeholder="Enter Aadhaar Number"
                                value={formData.aadhaar_no}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />

                              {errors.aadhaar_no && (
                                <div className="text-danger mt-1 small">
                                  {errors.aadhaar_no}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-12">
                        <div class="form-group mb-3">
                          <label>
                            Divyang <span class="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select form-control-sm ${
                              errors.divyangList ? "is-invalid" : ""
                            }`}
                            id="divyang_val"
                            name="divyang_val"
                            value={formData.divyang_val}
                            onChange={handleChange}
                            disabled={isPreviewed}
                          >
                            <option value="">Select</option>
                            {divyangList.map((divyang) => (
                              <option
                                key={divyang.divyanG_ID}
                                value={divyang.divyanG_ID}
                              >
                                {divyang.divyanG_NAME}
                              </option>
                            ))}
                          </select>
                          {errors.divyang_val && (
                            <div className="text-danger mt-1 small">
                              {errors.divyang_val}
                            </div>
                          )}
                        </div>
                        <div class="form-group mb-3">
                          <label>
                            Caste <span class="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select form-control-sm caste ${
                              errors.caste_val ? "is-invalid" : ""
                            }`}
                            name="caste_val"
                            id="caste_val"
                            value={formData.caste_val}
                            onChange={handleChange}
                            disabled={isPreviewed}
                          >
                            <option value="">Choose Caste</option>
                            {casteList.map((caste) => (
                              <option
                                key={caste.castE_ID}
                                value={caste.castE_ID}
                              >
                                {caste.castE_NAME}
                              </option>
                            ))}
                          </select>
                          {errors.caste_val && (
                            <div className="text-danger mt-1 small">
                              {errors.caste_val}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 mb-4 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 class="mb-0 p-2">Permanent Address</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div
                        class="col-lg-9 col-m-12"
                        style={{ borderRight: "1px solid #CED4DA" }}
                      >
                        <div class="row">
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group mb-3">
                              <label>
                                Area <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control-sm  ${
                                  errors.area ? "is-invalid" : ""
                                }`}
                                name="area"
                                id="area"
                                value={formData.area}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Choose Area</option>
                                <option value="RURAL">RURAL </option>
                                <option value="URBAN">URBAN</option>
                              </select>
                              {errors.area && (
                                <div className="text-danger mt-1 small">
                                  {errors.area}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                name="state_val"
                                id="state_val"
                                options={stateList.map((state) => ({
                                  value: state.statE_CODE,
                                  label: state.statE_NAME,
                                }))}
                                value={
                                  formData.state_val
                                    ? {
                                        value: formData.state_val,
                                        label:
                                          stateList.find(
                                            (s) =>
                                              s.statE_CODE ===
                                              formData.state_val
                                          )?.statE_NAME || "",
                                      }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleChange({
                                    target: {
                                      name: "state_val",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isPreviewed}
                                classNamePrefix={
                                  errors.state_val
                                    ? "react-select is-invalid"
                                    : "react-select"
                                }
                              />
                              {errors.state_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.state_val}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group mb-3">
                              <label>
                                District <span class="text-danger">*</span>
                              </label>
                              <Select
                                name="district_val"
                                id="district_val"
                                options={districtList
                                  .filter(
                                    (d) => d.statE_CODE === formData.state_val
                                  )
                                  .map((district) => ({
                                    value: district.districT_CODE,
                                    label: district.district,
                                  }))}
                                value={
                                  formData.district_val
                                    ? {
                                        value: formData.district_val,
                                        label:
                                          districtList.find(
                                            (d) =>
                                              d.districT_CODE ===
                                              formData.district_val
                                          )?.district || "",
                                      }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleChange({
                                    target: {
                                      name: "district_val",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isPreviewed || !formData.state_val}
                                classNamePrefix={
                                  errors.district_val
                                    ? "react-select is-invalid"
                                    : "react-select"
                                }
                              />
                              {errors.district_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.district_val}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group mb-3">
                              <label>
                                Block <span class="text-danger">*</span>
                              </label>
                              <Select
                                name="block_val"
                                id="block_val"
                                options={blockList
                                  .filter(
                                    (b) => b.disT_CODE === formData.district_val
                                  )
                                  .map((block) => ({
                                    value: block.blocK_ID,
                                    label: block.blocK_NAME,
                                  }))}
                                value={
                                  formData.block_val
                                    ? {
                                        value: formData.block_val,
                                        label:
                                          blockList.find(
                                            (b) =>
                                              b.blocK_ID === formData.block_val
                                          )?.blocK_NAME || "",
                                      }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleChange({
                                    target: {
                                      name: "block_val",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={
                                  isPreviewed || !formData.district_val
                                }
                                classNamePrefix={
                                  errors.block_val
                                    ? "react-select is-invalid"
                                    : "react-select"
                                }
                              />
                              {errors.block_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.block_val}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-9 col-m-6">
                            <div class="form-group mb-3">
                              <label>
                                Address <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="address_val"
                                className={`form-control form-control-sm  ${
                                  errors.address_val ? "is-invalid" : ""
                                }`}
                                maxlength="200"
                                placeholder="Enter Your Address"
                                value={
                                  formData.address_val?.toUpperCase() || ""
                                }
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.address_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.address_val}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group mb-3">
                              <label>
                                Pin Code <span class="text-danger">*</span>
                              </label>
                              <input
                                autoComplete="off"
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.pin_no ? "is-invalid" : ""
                                }`}
                                name="pin_no"
                                maxLength="6"
                                placeholder="Enter Your Pincode"
                                value={formData.pin_no}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              />
                              {errors.pin_no && (
                                <div className="text-danger mt-1 small">
                                  {errors.pin_no}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 col-m-12">
                        <div class="row">
                          <div class="form-group mb-3 col-m-6">
                            <label>
                              Contact Number <span class="text-danger">*</span>
                            </label>
                            <input
                              autoComplete="off"
                              type="text"
                              id="contact_no"
                              name="contact_no"
                              className={`form-control form-control-sm ${
                                errors.contact_no ? "is-invalid" : ""
                              }`}
                              maxlength="10"
                              placeholder="Student Contact Number"
                              value={formData.contact_no}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            />
                            {errors.contact_no && (
                              <div className="text-danger mt-1 small">
                                {errors.contact_no}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3 col-m-6">
                            <label>Email ID</label>
                            <input
                              type="email"
                              name="email_id"
                              className={`form-control form-control-sm  ${
                                errors.email_id ? "is-invalid" : ""
                              }`}
                              maxlength="100"
                              placeholder="Email ID"
                              value={formData.email_id}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            />
                            {errors.email_id && (
                              <div className="text-danger mt-1 small">
                                {errors.email_id}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-9 col-m-12 mb-4 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 class="mb-0 p-2">Educational Details</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group">
                        <div class="row">
                          {/* <div class="col-lg-4 col-m-4">
                                <div class="form-group mb-3">
                                  <label>
                                    Category Choice{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    className={`form-select form-select-sm category_name ${errors.category_choice ? "is-invalid" : ""
                                      }`}
                                    id="category_choice"
                                    name="category_choice"
                                    value={formData.category_choice}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  >
                                    <option value="">Choose Category</option>
                                    <option value="REGULAR">REGULAR</option>
                                    <option value="PRIVATE">PRIVATE</option>
                                  </select>
                                  {errors.category_choice && (
                                    <div className="text-danger mt-1 small">
                                      {errors.category_choice}
                                    </div>
                                  )}
                                </div>
                              </div> */}
                          <div class="col-lg-4 col-m-4">
                            <div class="form-group mb-3">
                              <label>
                                Board Name<span class="text-danger">*</span>
                              </label>
                              {/* <select
                                  className={`form-select form-control-sm  ${
                                    errors.board_name ? "is-invalid" : ""
                                  }`}
                                  name="board_name"
                                  value={formData.board_name}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                >
                                  <option value="">Choose Board</option>
                                  <option value="JAC" selected>
                                    JAC
                                  </option>
                                  <option value="CBSE">CBSE</option>
                                  <option value="ICSE">ICSE</option>
                                  <option value="OTHERS">OTHERS</option>
                                </select> */}
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={formData.board_name}
                                disabled
                              ></input>
                              {errors.board_name && (
                                <div className="text-danger mt-1 small">
                                  {errors.board_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-4 col-m-4">
                            <div class="form-group mb-3">
                              <label>
                                Medium of Examination{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control-sm  ${
                                  errors.examination_medium ? "is-invalid" : ""
                                }`}
                                name="examination_medium"
                                value={formData.examination_medium}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">
                                  Choose Medium of Examination
                                </option>
                                {mediumList.map((medium) => (
                                  <option
                                    key={medium.mediuM_ID}
                                    value={medium.mediuM_ID}
                                  >
                                    {medium.mediuM_NAME}
                                  </option>
                                ))}
                              </select>
                              {errors.examination_medium && (
                                <div className="text-danger mt-1 small">
                                  {errors.examination_medium}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-4 col-m-4">
                            <div className="form-group mb-3">
                              <label>
                                Academic Session&nbsp;
                                <span className="text-danger">*</span>
                              </label>
                              {/* <div className="row">
                                    <div style={{ width: "45%" }}>
                                      <input
                                        type="text"
                                        className={`form-control form-control-sm ${errors.academiC_SESSION1
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        maxLength="4"
                                        name="academiC_SESSION1"
                                        id="academiC_SESSION1"
                                        ref={session1Ref}
                                        value={formData.academiC_SESSION1}
                                        onChange={handleChange}
                                        disabled={isPreviewed}
                                      />
                                      {errors.academiC_SESSION1 && (
                                        <div className="text-danger mt-1 small">
                                          {errors.academiC_SESSION1}
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        width: "10%",
                                        fontSize: "28px",
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      -
                                    </div>
                                    <div style={{ width: "45%" }}>
                                      {" "}
                                      <input
                                        type="text"
                                        className={`form-control form-control-sm ${errors.academiC_SESSION2
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                        maxLength="4"
                                        name="academiC_SESSION2"
                                        id="academiC_SESSION2"
                                        ref={session2Ref}
                                        value={formData.academiC_SESSION2}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                        disabled={isPreviewed}
                                      />
                                      {errors.academiC_SESSION2 && (
                                        <div className="text-danger mt-1 small">
                                          {errors.academiC_SESSION2}
                                        </div>
                                      )}
                                    </div>
                                  </div> */}
                              <select
                                className={`form-select form-select-sm ${
                                  errors.academiC_SESSION ? "is-invalid" : ""
                                }`}
                                id="academiC_SESSION"
                                name="academiC_SESSION"
                                value={formData.academiC_SESSION}
                                onChange={handleChange}
                                disabled={isPreviewed}
                              >
                                <option value="">Choose Session</option>
                                {sessionList.map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.nO_DATA_FOUND_SESSION}
                                  >
                                    {item.nO_DATA_FOUND_SESSION}
                                  </option>
                                ))}
                              </select>
                              {errors.academiC_SESSION && (
                                <div className="text-danger mt-1 small">
                                  {errors.academiC_SESSION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div className="col-lg-4 col-m-4">
                            <div className="form-group mb-3">
                              <label>
                                Language I Subject{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                isSearchable={true}
                                isClearable={true}
                                classNamePrefix="react-select"
                                className={
                                  errors.language_one ? "is-invalid" : ""
                                }
                                name="language_one"
                                isDisabled={isPreviewed}
                                placeholder="Choose Language I Subject"
                                value={
                                  getFilteredSubjectOptions(lang2).find(
                                    (opt) => opt.value === lang1
                                  ) || null
                                }
                                onChange={(selected) => {
                                  setLang1(selected?.value || "");
                                  setFormData((prev) => ({
                                    ...prev,
                                    language_one: selected?.value || "",
                                  }));
                                }}
                                options={getFilteredSubjectOptions([
                                  lang2,
                                  addisubj,
                                ])}
                              />
                              {errors.language_one && (
                                <div className="text-danger mt-1 small">
                                  {errors.language_one}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-4 col-m-4">
                            <div className="form-group mb-3">
                              <label>
                                Language II Subject{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                isSearchable={true}
                                isClearable={true}
                                classNamePrefix="react-select"
                                className={
                                  errors.language_two ? "is-invalid" : ""
                                }
                                name="language_two"
                                isDisabled={isPreviewed}
                                placeholder="Choose Language II Subject"
                                value={
                                  getFilteredSubjectOptions(lang1).find(
                                    (opt) => opt.value === lang2
                                  ) || null
                                }
                                onChange={(selected) => {
                                  setLang2(selected?.value || "");
                                  setFormData((prev) => ({
                                    ...prev,
                                    language_two: selected?.value || "",
                                  }));
                                }}
                                options={getFilteredSubjectOptions([
                                  lang1,
                                  addisubj,
                                ])}
                              />
                              {errors.language_two && (
                                <div className="text-danger mt-1 small">
                                  {errors.language_two}
                                </div>
                              )}
                            </div>
                          </div>

                          <div class="col-lg-4 col-m-4">
                            <div class="form-group mb-3">
                              <label>
                                Compulsory I Subject{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm  ${
                                  errors.compulsory_one ? "is-invalid" : ""
                                }`}
                                name="compulsory_one"
                                id="compulsory_one"
                                value={compulsary[0]?.subjecT_NAME || ""}
                                disabled={true}
                              />
                              {errors.compulsory_one && (
                                <div className="text-danger mt-1 small">
                                  {errors.compulsory_one}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-4 col-m-4">
                            <div class="form-group mb-3">
                              <label>
                                Compulsory II Subject{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm  ${
                                  errors.compulsory_two ? "is-invalid" : ""
                                }`}
                                name="compulsory_two"
                                id="compulsory_two"
                                value={compulsary[1]?.subjecT_NAME || ""}
                                disabled={true}
                              />
                              {errors.compulsory_two && (
                                <div className="text-danger mt-1 small">
                                  {errors.compulsory_two}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-4 col-m-4">
                            <div class="form-group mb-3">
                              <label>
                                Compulsory III Subject{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm  ${
                                  errors.compulsory_three ? "is-invalid" : ""
                                }`}
                                name="compulsory_three"
                                id="compulsory_three"
                                value={compulsary[2]?.subjecT_NAME || ""}
                                disabled={true}
                              />
                              {errors.compulsory_three && (
                                <div className="text-danger mt-1 small">
                                  {errors.compulsory_three}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-4 col-m-4">
                            <div className="form-group mb-3">
                              <label>
                                Additional Subject{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                isSearchable={true}
                                isClearable={true}
                                classNamePrefix="react-select"
                                className={
                                  errors.additional_subject ? "is-invalid" : ""
                                }
                                name="additional_subject"
                                isDisabled={isPreviewed}
                                placeholder="Choose Additional Subject"
                                value={
                                  getFilteredSubjectOptions(
                                    [lang1, lang2],
                                    "additional"
                                  ).find((opt) => opt.value === addisubj) ||
                                  null
                                }
                                onChange={(selected) => {
                                  setAddisubj(selected?.value || "");
                                  setFormData((prev) => ({
                                    ...prev,
                                    additional_subject: selected?.value || "",
                                  }));
                                }}
                                options={getFilteredSubjectOptions(
                                  [lang1, lang2],
                                  "additional"
                                )}
                              />

                              {errors.additional_subject && (
                                <div className="text-danger mt-1 small">
                                  {errors.additional_subject}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-m-12 mb-4 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 class="mb-0 p-2">Other Details</h4>
                  </div>
                  <div class="card-body">
                    {/* <div class="form-group mb-3">
                          <label>Permanent Education Number (PEN)</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            id="pen_no"
                            name="pen_no"
                            className={`form-control form-control-sm ${
                              errors.pen_no ? "is-invalid" : ""
                            }`}
                            placeholder="Enter PEN NO"
                            value={formData.pen_no}
                            maxlength="12"
                            onChange={(e) => {
                              const onlyNums2 = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              handleChange({
                                target: { name: "pen_no", value: onlyNums2 },
                              });
                            }}
                            disabled={isPreviewed}
                          />
                          {errors.pen_no && (
                            <div className="text-danger mt-1 small">
                              {errors.pen_no}
                            </div>
                          )}
                        </div> */}

                    <div class="form-group mb-3">
                      <label>APAAR ID</label>
                      <input
                        maxlength="20"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        id="apaar_id"
                        name="apaar_id"
                        className="form-control form-control-sm"
                        placeholder="Enter APAAR ID"
                        value={formData.apaar_id}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(/\D/g, "");
                          handleChange({
                            target: { name: "apaar_id", value: onlyNums },
                          });
                        }}
                        disabled={isPreviewed}
                      />
                      {/* {errors.apaar_id && (
                            <div className="text-danger mt-1 small">
                              {errors.apaar_id}
                            </div>
                          )} */}
                    </div>

                    {/* <div class="form-group mb-3">
                          <label>
                            Section <span class="text-danger">*</span>
                          </label>
                          <select
                            className={`form-select form-control-sm ${errors.section_val ? "is-invalid" : ""
                              }`}
                            id="section_val"
                            name="section_val"
                            value={formData.section_val}
                            onChange={handleChange}
                            disabled={isPreviewed}
                          >
                            <option value="">Choose Section</option>
                            {[
                              "A",
                              "B",
                              "C",
                              "D",
                              "E",
                              "F",
                              "G",
                              "H",
                              "I",
                              "J",
                              "K",
                              "L",
                              "M",
                              "N",
                              "O",
                              "P",
                              "Q",
                              "R",
                              "S",
                              "T",
                              "U",
                              "V",
                              "W",
                              "X",
                              "Y",
                              "Z",
                            ].map((sec) => (
                              <option key={sec} value={sec}>
                                {sec}
                              </option>
                            ))}
                          </select>
                          {errors.section_val && (
                            <div className="text-danger mt-1 small">
                              {errors.section_val}
                            </div>
                          )}
                        </div> */}

                    {/* <div class="form-group  mb-3">
                          <label>
                            Class Roll No.<span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="roll_no"
                            id="roll_no"
                            maxlength="3"
                            className={`form-control form-control-sm  ${errors.roll_no ? "is-invalid" : ""
                              }`}
                            placeholder="Enter Exam Roll No."
                            value={formData.roll_no}
                            onChange={handleChange}
                            disabled={isPreviewed || !formData.section_val}
                          />
                          {errors.roll_no && (
                            <div className="text-danger mt-1 small">
                              {errors.roll_no}
                            </div>
                          )}
                        </div> */}
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-md-8">
                        {isPreviewed && (
                          <h5 style={{ color: "red" }}>
                            <input
                              type="checkbox"
                              checked={isAgreed}
                              onChange={(e) => setIsAgreed(e.target.checked)}
                            />{" "}
                            I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                            CORRECT AS PER MY BEST KNOWLEDGE.
                          </h5>
                        )}
                      </div>
                      <div style={{ textAlign: "right" }} className="col-md-4">
                        {isPreviewed ? (
                          <>
                            <button
                              onClick={handleSubmit}
                              type="button"
                              className="btn btn-primary pull-right"
                            >
                              <i className="fa fa-save me-1"></i>
                              Submit
                            </button>
                            <button
                              type="button"
                              onClick={() => setIsPreviewed(false)}
                              className="btn btn-secondary me-2"
                            >
                              <i className="fa fa-edit me-1"></i> Edit
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-secondary me-2"
                            onClick={handlePreview}
                          >
                            <i className="fa fa-eye me-1"></i> Preview
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer10 />
        </div>
      </div>
    </div>
  );
}

export default DataNotFound10;
